import { ContactUsModal } from '@mdvip/shared/components/support/ContactUsModal';
import { ContactPage } from '@mdvip/shared/pages/ContactPage';
import { useState } from 'react';
import { useMemberContactPrefill } from '@/hooks/member/useMemberContactPrefill';

/**
 * The `/contact` route element: connects the shared `ContactPage` to the shared `ContactUsModal`.
 *
 * The glue is app-local on purpose. Both components it renders are shared and role-agnostic —
 * `ContactPage` because legacy serves the same Help & Support page to member and physician/staff
 * sessions, `ContactUsModal` because it takes its prefill as props rather than fetching. Resolving
 * `myMemberInfo` is member-only, so it belongs here. A future providers equivalent writes its own
 * wrapper without either shared component changing.
 */
export function ContactRoute() {
  const [open, setOpen] = useState(false);
  const { data: prefill } = useMemberContactPrefill();

  return (
    <>
      <ContactPage onOpenContact={() => setOpen(true)} />
      <ContactUsModal open={open} onOpenChange={setOpen} prefillName={prefill?.name} prefillEmail={prefill?.email} />
    </>
  );
}
